import { Suspense, useMemo } from "react";
import type { GridFilterModel } from "@mui/x-data-grid-premium";
import type {
  SupplierProcurementConditionResource,
  SupplierResource,
} from "@exonn/js-sdk";
import { ResourceList } from "src/system/ResourceList.tsx";
import { ResourceEnum } from "src/constants/constants.ts";
import { useResourceFormData } from "src/components/Form/hooks/useResourceFormData.ts";
import { useGlobalModuleTabs } from "src/App/useGlobalModuleTabs.ts";
import { FormAction } from "src/components/Form/Form.types.ts";
import { useEditDeleteContextMenu } from "src/system/list/context-menu/useEditDeleteContextMenu.tsx";

// Lieferkonditionen поставщика: по одной на манданта и тип закупки.
// Создание и правка — в форме условия (отдельная вкладка); меню строки — «Bearbeiten / Löschen».
export const SupplierConditions = () => {
  const data = useResourceFormData<{ data: SupplierResource }>();
  const supplierId = data?.data?.id;
  const { api } = useGlobalModuleTabs();
  const openCondition = (condition: SupplierProcurementConditionResource) =>
    api.openTab({
      resource: ResourceEnum.SupplierProcurementCondition,
      type: "form",
      action: FormAction.Edit,
      id: condition.id,
    });
  const contextMenu =
    useEditDeleteContextMenu<SupplierProcurementConditionResource>({
      resource: ResourceEnum.SupplierProcurementCondition,
      onEdit: openCondition,
    });

  const filter = useMemo(
    (): GridFilterModel => ({
      items: [{ field: "supplier_id", operator: "is", value: supplierId }],
    }),
    [supplierId],
  );

  if (!supplierId) {
    return null;
  }

  const createCondition = () => {
    const searchParams = new URLSearchParams();
    searchParams.set("supplier_id", supplierId);
    api.openTab({
      resource: ResourceEnum.SupplierProcurementCondition,
      type: "form",
      action: FormAction.Create,
      searchParams,
    });
  };

  return (
    <Suspense fallback={null}>
      <ResourceList
        style={{ padding: 15 }}
        resource={ResourceEnum.SupplierProcurementCondition}
        filter={filter}
        disableStatePersistenceToUrl
        onToolbarCreateNewRecord={createCondition}
        contextMenu={contextMenu}
        onRowDoubleClick={({
          row,
        }: {
          row: SupplierProcurementConditionResource;
        }) => openCondition(row)}
      />
    </Suspense>
  );
};
